import { render, staticRenderFns } from "./ManuscriptSelectContent.vue?vue&type=template&id=a3259cbe&scoped=true"
import script from "./ManuscriptSelectContent.vue?vue&type=script&lang=ts"
export * from "./ManuscriptSelectContent.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptSelectContent.vue?vue&type=style&index=0&id=a3259cbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3259cbe",
  null
  
)

export default component.exports